"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createAttribute = exports.fetchAttributes = void 0;

var _q = _interopRequireDefault(require("q"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _fetchAttributes = function _fetchAttributes(userId) {
  return _apiClient.default.get('users/v1/app/attributes', {
    query: {
      'user-id': userId
    }
  });
};

var fetchAttributes = function fetchAttributes(userId) {
  var resultPromise;
  var earlyRequest = window.quickFetch && window.quickFetch.getRequestStateByName('user-attributes');

  if (earlyRequest) {
    resultPromise = new _q.default.Promise(function (resolve, reject) {
      earlyRequest.whenFinished(function (result) {
        resolve(result);
        window.quickFetch.removeEarlyRequest('user-attributes');
      });
      earlyRequest.onError(function () {
        _fetchAttributes(userId).then(resolve, reject);

        window.quickFetch.removeEarlyRequest('user-attributes');
      });
    });

    if (window.newrelic) {
      window.newrelic.setCustomAttribute('user-attributes-early-request-used', Boolean(earlyRequest.finished));
    }
  } else {
    resultPromise = _fetchAttributes(userId);
  }

  return resultPromise;
};

exports.fetchAttributes = fetchAttributes;

var createAttribute = function createAttribute(userId, key, value) {
  return _apiClient.default.post('users/v1/app/attributes', {
    data: {
      userId: userId,
      key: key,
      value: value
    }
  });
};

exports.createAttribute = createAttribute;